module.exports = __webpack_public_path__ + "static/scale-model-of-kent-washington-2434a3d5a1f25f327934ea7ac1dd87e1.png";